
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MerchandiseOverview from './MerchandiseOverview';
import ProductsList from './ProductsList';
import StoreSettings from './StoreSettings';
import StoreIntegrations from './StoreIntegrations';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import CreateProductModal from './CreateProductModal';

const MerchandiseStore = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div className="w-full">
          <Tabs value={activeTab} onValueChange={setActiveTab} defaultValue="overview">
            <TabsList>
              <TabsTrigger value="overview">Overview</TabsTrigger>
              <TabsTrigger value="products">Products</TabsTrigger>
              <TabsTrigger value="integrations">Integrations</TabsTrigger>
              <TabsTrigger value="settings">Settings</TabsTrigger>
            </TabsList>
            
            <TabsContent value="overview" className="mt-6">
              <MerchandiseOverview />
            </TabsContent>
            
            <TabsContent value="products" className="mt-6">
              <ProductsList />
            </TabsContent>
            
            <TabsContent value="integrations" className="mt-6">
              <StoreIntegrations />
            </TabsContent>
            
            <TabsContent value="settings" className="mt-6">
              <StoreSettings />
            </TabsContent>
          </Tabs>
        </div>
        <Button onClick={() => setIsCreateModalOpen(true)} className="ml-4 flex-shrink-0">
          <Plus className="h-4 w-4 mr-2" />
          Add Product
        </Button>
      </div>

      <CreateProductModal 
        isOpen={isCreateModalOpen} 
        onClose={() => setIsCreateModalOpen(false)} 
      />
    </div>
  );
};

export default MerchandiseStore;
